<template>
  <section>
    <div v-if="isLoading" class="flex flex-col gap-4 p-6">
      <div
        v-for="index in 4"
        :key="index"
        class="rounded-lg bg-white-100 p-4 skeleton-loader-wrapper"
      >
        <aha-skeleton-loader
          class="rounded-lg"
          width="100%"
          height="150px"
        />
      </div>
    </div>
    <div class="p-6 flex flex-col gap-4" v-else>
      <template
        v-for="(answer, index) in answers"
      >
        <AnswersAndSubmissions
          :dataAnswer="answer"
          :key="`answer-${index}`"
          :order="index + 1"
          :totalQuiz="answers?.length"
        />
      </template>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import AnswersAndSubmissions from '@/components-v2/presentation-report/ReportAudienceDetail/AnswersAndSubmissions.vue'

export default {
  title: 'Responses',
  name: 'Responses',
  components: {
    AnswersAndSubmissions,
  },
  props: {
    presentationId: {
      type: String,
      required: true,
    },
    audienceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters('presentationReport', [
      'participantAnswers',
      'canUseDataMartIndividualReport',
    ]),

    answers() {
      if (this.canUseDataMartIndividualReport) {
        return this.participantAnswers?.map((answer) => {
          return {
            ...answer,
            slideDetails: {
              slideType: answer.question_type,
              type: answer.question_type,
              slideId: answer.slide_id,
              order: answer.order,
              title: answer.question_title,
              image: answer.question_image,
            },
          }
        })
      }

      return this.participantAnswers
    },
  },
  mounted() {
    this.getAnswers()
  },
  methods: {
    ...mapActions('presentationReport', ['getParticipantAnswers']),
    async getAnswers() {
      this.isLoading = true
      try {
        await this.getParticipantAnswers({
          presentationId: this.presentationId,
          audienceId: this.audienceId,
        })
      } catch (e) {
        Sentry.captureException(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .skeleton-loader-wrapper {
    width: auto;
    height: auto;

  }
</style>
